<template>
  <div class="mb-48">
    <T1Breadcrumbs class="mb-24" :homeLink="true" :items="getBreadcrumbs()" />
    <h1 class="font-24 font-r mb-24">Pogoda i klimat - {{ selectedRegion }}</h1>
    <a-row :gutter="32" class="meteo-content">
      <a-col :xs="24" :lg="16" :xl="17" class="meteo-content__main mb-48">
        <div class="mb-24 pt-6">
          <template v-for="(textLine, idx) in excerptText">
            <p :key="idx">{{ textLine }}</p>
          </template>
        </div>
        <T1Tabs tabLabelType="h2">
          <T1Tab key="1" title="Prognoza pogody" renderContent>
            <T1Forecast :meteoData="meteoData" />
          </T1Tab>
          <T1Tab key="2" title="Klimat">
            <T1MeteoCharts :climateData="climateData" />
          </T1Tab>
          <T1Tab
            key="3"
            title="Kiedy jechać?"
            v-if="meteoData.KiedyJechac"
            renderContent
          >
            <T1WhenToGo
              :meteoDesc="meteoData.KiedyJechac"
              :countryName="countryname"
            />
          </T1Tab>
        </T1Tabs>
      </a-col>
      <a-col :xs="24" :lg="8" :xl="7" class="meteo-content__select">
        <div class="mb-24">
          <div class="content-panel-flat panel-yellow">
            <div class="font-m mb-6">{{ countryname }} - pogoda i klimat:</div>
            <div class="form-control-yellow">
              <a-config-provider :locale="pl_PL">
                <a-select
                  class="mb-6 w-100"
                  ref="select"
                  v-model="selectedRegion"
                  @change="handleChange"
                >
                  <a-select-option
                    v-for="({ locid, nazwa, region }, idx) in regionsData"
                    :key="idx"
                    :value="locid"
                  >
                    {{ nazwa }}
                    <template v-if="region.length > 0">({{ region }})</template>
                  </a-select-option>
                </a-select>
              </a-config-provider>
            </div>
          </div>
        </div>
      </a-col>
      <a-col :xs="24" :lg="8" :xl="7" class="meteo-content__offers">
        <div class="mb-24">
          <h2 class="font-20 mb-24 mb-md-12" v-if="showOffers()">
            Oferty w okolicy
          </h2>
          <a-row :gutter="[0, 24]" type="flex">
            <a-col
              :xs="24"
              :sm="12"
              :lg="24"
              v-for="(item, idx) in topoffers"
              :key="idx"
            >
              <T1TopOfferCard v-if="idx < 4" :oferta="getOfertyItems(idx)" />
            </a-col>
          </a-row>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import * as CONFIG from "./config.js";
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";
import T1Tabs from "./T1Tabs/T1Tabs";
import T1Tab from "./T1Tabs/T1Tab";
import T1Forecast from "./T1PogodaKlimat/T1Forecast";
import T1MeteoCharts from "./T1PogodaKlimat/T1MeteoCharts";
import T1WhenToGo from "./T1PogodaKlimat/T1WhenToGo";
import T1TopOfferCard from "./T1OfferCards/T1TopOfferCard";
import pl_PL from "ant-design-vue/lib/locale-provider/pl_PL";
import moment from "moment";
import "moment/locale/pl";
moment.locale("pl");

export default {
  name: "pogoda-klimat-content",
  data: () => ({
    pl_PL,
    url: "/getvuemeteodata.json",
    topoffersurl: "/vueoffers.json",
    countrylocid: CONFIG.locid,
    countryname: CONFIG.panstwo_nazwapl,
    serwis: CONFIG.serwis,
    locid: "",
    climateData: {},
    excerptText: {},
    meteoData: {},
    regionsData: {},
    selectedRegion: "",
    topoffers: [],
    cheapestOfferPrice: ""
  }),
  methods: {
    tomatrix(obj) {
      if (obj != undefined) {
        if (obj instanceof Array) {
          return obj;
        } else {
          let z = [];
          z.push(obj);
          return z;
        }
      } else {
        return [];
      }
    },
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push({ name: "Pogoda i klimat", link: "" });
      return crumbsArr;
    },
    showOffers() {
      return this.topoffers.length > 0;
    },
    getTopOffers() {
      var pars = "top=10&locid=" + this.locid;
      return axios
        .get(CONFIG.API_URL + this.topoffersurl + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          }
        })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          alert("ERROR" + e);
        });
    },
    getMeteoData() {
      var pars = "locid=" + this.locid;
      return axios
        .get(CONFIG.API_URL + this.url + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          }
        })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          alert("ERROR" + e);
        });
    },
    getOfertyItems(i) {
      if (this.topoffers.length > i) {
        return this.topoffers[i];
      } else {
        return {};
      }
    },
    getLeadExcerpt() {
      this.excerptText = this.meteoData.KiedyJechac.punkty.slice(0, 2);
      return this.excerptText;
    },
    handleChange(value) {
      this.locid = value;
      this.getMeteoData().then(data => {
        this.meteoData = data.Page.MeteoData;
        this.regionsData = this.tomatrix(
          this.meteoData.lokalizacje.lokalizacja
        );
        this.climateData = this.meteoData.location.climatedata;
        this.getTopOffers().then(data3 => {
          this.topoffers = data3.page.response;
          if (
            (this.topoffers && typeof this.topoffers === "object") ||
            this.topoffers.length > 0
          ) {
            var topoffersarr = [];
            if (this.topoffers instanceof Array) {
              topoffersarr = this.topoffers;
            } else {
              topoffersarr.push(this.topoffers.grp);
              this.topoffers = topoffersarr;
            }
            if (topoffersarr.lenght > 0) {
              this.cheapestOfferPrice = topoffersarr
                .map(function(elem) {
                  return elem.ofr.price;
                })
                .reduce(function(elem) {
                  return Math.min(elem).toString();
                });
            }
          }
        });
      });

      let updateRegion = this.regionsData.filter(function(obj) {
        return obj.locid == value;
      });

      this.selectedRegion =
        updateRegion[0].region.length > 0
          ? updateRegion[0].nazwa + " (" + updateRegion[0].region + ")"
          : updateRegion[0].nazwa;
    }
  },
  mounted() {
    let that = this;

    this.getMeteoData().then(data => {
      this.meteoData = data.Page.MeteoData;
      this.regionsData = this.tomatrix(this.meteoData.lokalizacje.lokalizacja);
      this.climateData = this.meteoData.location.climatedata;
      this.locid = this.meteoData.locid;

      this.selectedRegion =
        this.regionsData[0].region.length > 0
          ? this.regionsData[0].nazwa + " (" + this.regionsData[0].region + ")"
          : this.regionsData[0].nazwa;

      this.getLeadExcerpt();
      that.getTopOffers().then(data3 => {
        that.topoffers = data3.page.response;

        if (
          (that.topoffers && typeof that.topoffers === "object") ||
          that.topoffers.length > 0
        ) {
          var topoffersarr = [];
          if (that.topoffers instanceof Array) {
            topoffersarr = that.topoffers;
          } else {
            topoffersarr.push(that.topoffers.grp);
            that.topoffers = topoffersarr;
          }
          if (topoffersarr.lenght > 0) {
            this.cheapestOfferPrice = topoffersarr
              .map(function(elem) {
                return elem.ofr.price;
              })
              .reduce(function(elem) {
                return Math.min(elem).toString();
              });
          }
        }
      });
    });
  },
  components: {
    T1Breadcrumbs,
    T1Tabs,
    T1Tab,
    T1Forecast,
    T1MeteoCharts,
    T1WhenToGo,
    T1TopOfferCard
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: $screen-sm-max) {
  .meteo-content {
    display: flex;
    flex-wrap: wrap;

    &__main {
      order: 1;
    }

    &__select {
      order: 0;
    }

    &__offers {
      order: 2;
    }
  }
}
</style>
